import React, { Fragment } from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import AlertOFLC from "../../../global/containers/AlertOFLC";
import GQLUtil from "../../../global/utils/gqlHelper";
import DeleteEntityQueryResolver from "./queries/resolver";
import { withRouter } from "react-router-dom";

class DeleteEntityModal extends React.Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
    };
  }

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    const {
      menuItemStyle,
      isMainEntity,
      deleteSubNoun,
      deleteMainNoun,
      formName,
      history,
      customMessage,
    } = this.props;

    const deleteEntity = (e) => {
      let id = e.target.id;
      let query = DeleteEntityQueryResolver(formName, id);
      GQLUtil.genericGQLQuery(query).then(() => {
        this.closeModal();
        history.push(this.props.location.pathname);
      });
    };

    const modalStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };

    const modalContentStyle = {
      maxWidth: "400px",
      padding: "20px",
    };

    const buttonGroupStyle = {
      marginTop: "25px",
      display: "flex",
    };

    const cancelButtonStyle = {
      flex: 1,
    };

    const deleteButtonStyle = {
      flex: 1,
      color: "#9b1a1b",
      boxShadow: "#9b1a1b 0px 0px 0px 2px inset",
    };

    const closeButton = {
      position: "absolute",
      right: "20px",
      top: "20px",
      background: "none",
      border: "none",
      padding: 0,
    };

    const closeButtonIcon = {
      height: "40px",
      width: "40px",
    };

    return (
      <Fragment>
        <button
          style={menuItemStyle}
          className="menu-item menu-item-button dropdown-label-View"
          type="button" // This removes default submit
          onClick={this.openModal}
        >
          <span>Delete</span>
        </button>
        <Modal
          style={modalStyles}
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          overlayClassName="Overlay"
        >
          <button style={closeButton} onClick={this.closeModal} type="button">
            <MdClose style={closeButtonIcon} />
          </button>
          <div className="delete-profile-container" style={modalContentStyle}>
            <h3>Are you sure you want to delete?</h3>
            {(customMessage && <p>{customMessage}</p>) ||
              (isMainEntity && (
                <p>{`This will also delete the ${deleteSubNoun} associated with this ${deleteMainNoun}.`}</p>
              ))}

            <AlertOFLC type="grey">This action cannot be undone</AlertOFLC>

            <div style={buttonGroupStyle}>
              <button
                style={cancelButtonStyle}
                onClick={this.closeModal}
                className="usa-button usa-button--outline"
              >
                Cancel
              </button>
              <button
                style={deleteButtonStyle}
                onClick={deleteEntity}
                className="usa-button usa-button--outline"
                id={this.props.id}
                formName={formName}
              >
                Delete
              </button>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(DeleteEntityModal);
